import React from "react";

const DEFAULT_BORDER_WIDTH = "0px";
const BUTTON_BASE_CLASS =
  "w-max h-max rounded-md font-montserrat transition-colors disabled:cursor-not-allowed disabled:opacity-45";
const BUTTON_SIZE_CLASSES = Object.freeze({
  compact: "min-h-[34px] px-[0.7rem] py-[0.4rem] text-[0.78rem] font-[700]",
  default: "p-[7px_11px] font-[500]",
});
const BUTTON_TONE_CLASSES = Object.freeze({
  actionClear:
    "bg-action-clear text-action-clear-text hover:bg-action-clear-hover",
  actionDelete:
    "bg-action-delete text-action-delete-text hover:bg-action-delete-hover",
  actionSave: "bg-action-save text-action-save-text hover:bg-action-save-hover",
  actionView: "bg-action-view text-action-view-text hover:bg-action-view-hover",
  danger: "bg-danger text-on-danger hover:bg-danger-hover",
  primary: "bg-primary text-on-primary hover:bg-primary-hover",
  secondary: "border border-border bg-surface text-text hover:bg-surface-muted",
  success: "bg-success text-on-success hover:bg-success-hover",
  warning: "bg-warning text-on-warning hover:bg-warning-hover",
});

const getLegacyButtonClass = ({ backGroundColor, hoverColor, textColor }) =>
  [backGroundColor, textColor, hoverColor].filter(Boolean).join(" ");

const getButtonClassName = (props) => {
  const toneClass = props.tone
    ? BUTTON_TONE_CLASSES[props.tone]
    : getLegacyButtonClass(props);

  return [
    BUTTON_BASE_CLASS,
    BUTTON_SIZE_CLASSES[props.size],
    toneClass,
    props.className,
  ].filter(Boolean).join(" ");
};

const getButtonStyle = ({ borderColor, borderWidth, style }) => {
  if (borderWidth === DEFAULT_BORDER_WIDTH) return style;

  return { border: `${borderWidth} solid ${borderColor}`, ...style };
};

const ButtonComponent = ({
  buttonName = "Default",
  onClick = () => {},
  backGroundColor = "bg-black",
  textColor = "text-white",
  hoverColor,
  borderColor = "black",
  borderWidth = DEFAULT_BORDER_WIDTH,
  style,
  className,
  disabled = false,
  size = "default",
  tone,
  type,
}) => {
  return (
    <button
      className={getButtonClassName({
        backGroundColor,
        className,
        hoverColor,
        size,
        textColor,
        tone,
      })}
      disabled={disabled}
      onClick={onClick}
      style={getButtonStyle({ borderColor, borderWidth, style })}
      type={type}
    >
      {buttonName}
    </button>
  );
};

export default ButtonComponent;
